
export const rgbToHex = ({ r, g, b }: {
    r: number;
    g: number;
    b: number;
}): string => {
    const toHex = (x: number) => x.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}